<template>
  <AppDrawer
    v-model="open"
    :title="t('agreement.title')"
    padded
    body-padding="22px 20px calc(32px + env(safe-area-inset-bottom))"
    :z-index="57"
    @back="closeAgreement"
  >
    <div class="ag-page">
      <!-- 标题卡 -->
      <header class="ag-hero">
        <span class="ag-hero-ic">▤</span>
        <div class="ag-hero-tx">
          <h2>{{ t('agreement.docTitle') }}</h2>
          <p>{{ t('agreement.docSubtitle') }}</p>
        </div>
      </header>

      <!-- 导读 -->
      <p class="ag-intro">{{ t('agreement.intro') }}</p>

      <!-- 章节 -->
      <section v-for="i in 8" :key="i" class="ag-sec">
        <div class="ag-sec-head">
          <span class="ag-sec-no">{{ i }}</span>
          <h2>{{ t(`agreement.s${i}Title`) }}</h2>
        </div>
        <p class="ag-sec-body">{{ t(`agreement.s${i}Body`) }}</p>
      </section>

      <!-- 底部 CTA：sticky 钉在可视区底部 -->
      <button type="button" class="ag-done" @click="closeAgreement">
        {{ t('agreement.done') }}
      </button>
    </div>
  </AppDrawer>
</template>

<script setup lang="ts">
const { t } = useI18n()
const { open, closeAgreement } = useAgreementNav()
</script>

<style scoped lang="scss">
.ag-page {
  padding-bottom: 28px;
}
.ag-hero {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 2px 2px 20px;
  border: 0;
  border-bottom: 1px solid var(--hairline);
  border-radius: 0;
  background: transparent;
  box-shadow: none;

  .ag-hero-ic {
    width: 42px;
    height: 42px;
    border-radius: 13px;
    color: var(--primary);
    background: rgba(var(--primary-rgb), 0.11);
    box-shadow: none;
    font-size: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    font-style: normal;
    font-weight: 900;
  }

  h2 {
    font-size: 18px;
    letter-spacing: 0.1px;
    font-weight: bold;
  }

  p {
    margin-top: 4px;
    font-size: 10.5px;
    color: var(--muted);
  }
}

.ag-intro {
  margin: 14px 0 4px;
  padding: 12px 13px;
  border: 0;
  border-radius: 12px;
  background: var(--surface2);
  font-size: 11px;
  line-height: 1.7;
  color: var(--muted);
}

.ag-sec {
  margin: 0;
  padding: 18px 2px;
  border: 0;
  border-bottom: 1px solid var(--hairline);
  border-radius: 0;
  background: transparent;
  box-shadow: none;

  .ag-sec-head {
    display: flex;
    align-items: center;
    gap: 9px;
    font-size: 14px;

    .ag-sec-no {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 23px;
      height: 23px;
      border-radius: 50%;
      color: #fff;
      background: linear-gradient(135deg, var(--primary), var(--primary2));
      font-size: 10px;
    }

    h2 {
      font-size: 14px;
      font-weight: 800;
    }
  }

  .ag-sec-body {
    margin: 9px 1px 0;
    color: var(--muted);
    font-size: 11.5px;
    line-height: 1.9;
  }
}

.ag-done {
  width: 100%;
  border-radius: 999px;
  color: #fff;
  background: linear-gradient(135deg, var(--primary), var(--primary2));
  box-shadow: var(--btn-glow);
  font-weight: 900;

  margin-top: 22px;
  padding: 13px;
  font-size: 13.5px;

  &:active {
    transform: scale(0.98);
  }
}
</style>
